import React, { useEffect } from 'react';
import './WellnessPage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Trans, useTranslation } from 'react-i18next'; 

import wellnessLogo from '../../../../../assets/logo-Nyhu.png';
import wellnessHero from '../../../../../assets/WellnessHero.png';
import yogaImg from '../../../../../assets/Yoga.png';
import bicicletasImg from '../../../../../assets/Bicicletas.png';
import solImg from '../../../../../assets/Homenaje-al-sol.png';
import soundHealingImg from '../../../../../assets/Soundhealing.png';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// 2. ---  IMÁGENES PARA EL PRIMER CARRUSEL ---
import carruselImg1 from '../../../../../assets/wellnes/wellness1.png'; 
import carruselImg2 from '../../../../../assets/wellnes/wellness2.png'; 
import carruselImg3 from '../../../../../assets/wellnes/wellness3.png'; 
import carruselImg4 from '../../../../../assets/wellnes/wellness4.png'; 

const activitiesMap = [
  { id: 'yoga', image: yogaImg },
  { id: 'sun', image: solImg },
  { id: 'sound', image: soundHealingImg },
];

const carouselImages = [
  carruselImg1,
  carruselImg2,
  carruselImg3,
  carruselImg4,
];

const WellnessPage: React.FC = () => {
  // 2. Hook
  const { t } = useTranslation();

  const pdfUrl = t('wellnessPage:intro.pdfUrl');

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="wellness-page">
      
      <div 
        className="wellness-hero" 
        style={{ backgroundImage: `url(${wellnessHero})` }} 
        data-aos="fade-in"
      >
        <div className="wellness-hero-content">
          <h1><Trans i18nKey="wellnessPage:heroTitle" /></h1>
        </div>
      </div>

      {/* --- Intro Section --- */}
      <section className="wellness-intro" data-aos="fade-up">
        <div className="wellness-intro-content">
          <img src={wellnessLogo} alt="Nyuh Wellness Spa" className="wellness-intro-logo" />
          <p>
            <Trans 
              i18nKey="wellnessPage:intro.description"
              components={{ strong: <strong /> }}
            />
          </p>
          <a 
            href={pdfUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="wellness-menu-button"
            style={{ textDecoration: 'none' }}
          >
            <span><Trans i18nKey="wellnessPage:intro.menuButton" /></span>
          </a>
        </div>
        {/* <div className="wellness-divider"></div> */}
      </section>

      <section className="vgrid-carrusel">
        <div className="restaurant-carousel-wrapper" data-aos="fade-left">
          <Swiper
            modules={[Navigation]} 
            navigation 
            slidesPerView={2}
            loop={true} 
            className="restaurant-swiper"
            breakpoints={{
              0: { slidesPerView: 1},
              769: { slidesPerView: 2},
            }}
          >
            {carouselImages.map((imgSrc, index) => (
              <SwiperSlide key={index}>
                <img
                  src={imgSrc}
                  alt={`Interior del restaurante ${index + 1}`}
                  className="restaurant-carousel-image"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* --- Actividades --- */}
      <section className="wellness-activities">
        <div className="activities-grid">
          {activitiesMap.map((activity) => (
            <div key={activity.id} className="activity-card" data-aos="fade-up">
              
              
              <h3 className="activity-title">
                {t(`wellnessPage:activities.${activity.id}.title`)}
              </h3>
              
              <div className="activity-image-container">
                <img src={activity.image} alt={activity.id} className="activity-image" />
              </div>
              
              <div className="activity-text">
                <p>
                  
                  <Trans 
                    i18nKey={`wellnessPage:activities.${activity.id}.description`}
                    components={{ strong: <strong /> }}
                  />
                </p>
                
                {activity.id === 'yoga' && (
                   <p className="activity-note">
                     {t(`wellnessPage:activities.${activity.id}.note`)}
                   </p>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="activities-footer-note" data-aos="fade-up">
          <p><Trans i18nKey="wellnessPage:footer.free" /></p>
          <p><Trans i18nKey="wellnessPage:footer.subjectTo" /></p>
        </div>
      </section>
    </div>
  );
};

export default WellnessPage;